import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import UnderHeader from "../components/UnderHeader"
import H2WithWave from "../components/h2WithWave"
import { Container, Row, Col } from "react-bootstrap"
import Button from "../components/button/Button"
import boatIcon from "../assets/icon-boat-wheel.svg"

const NotFoundPage = props => {
  const [countdown, setCountdown] = useState(10)
  const {
    pageContext: { serviceLocations },
  } = props

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          navigate("/")
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const handleGoHome = () => {
    navigate("/")
  }

  return (
    <Layout headerType="withSearch" serviceLocations={serviceLocations}>
      <SEO title="404: Page Not Found" />
      <UnderHeader title="Oops! Page Not Found" desc="The page you're looking for has sailed away" />
      
      <Container className="py-5">
        <Row className="justify-content-center text-center">
          <Col xs={12} md={8} lg={6}>
            <div className="mb-4">
              <img 
                src={boatIcon} 
                alt="Boat wheel" 
                width="80" 
                height="80"
                style={{ opacity: 0.6 }}
              />
            </div>
            
            <H2WithWave title="Don't worry, we'll get you back on course!" />
            
            <div className="mb-4">
              <h3 style={{ color: "#666", fontSize: "1.2rem", fontWeight: "normal" }}>
                The page you're looking for might have been:
              </h3>
              <ul style={{ 
                listStyle: "none", 
                padding: 0, 
                color: "#888",
                fontSize: "1rem",
                lineHeight: "1.8"
              }}>
                <li>• Moved to a new location</li>
                <li>• Temporarily unavailable</li>
                <li>• Removed from our site</li>
                <li>• Never existed (like a unicorn boat!)</li>
              </ul>
            </div>

            <div style={{ 
              background: "#f8f9fa", 
              border: "2px solid #e9ecef", 
              borderRadius: "10px",
              padding: "20px",
              margin: "30px 0"
            }}>
              <h4 style={{ color: "#495057", marginBottom: "10px" }}>
                🧭 Automatic Redirect
              </h4>
              <p style={{ color: "#6c757d", marginBottom: "15px" }}>
                You'll be redirected to our homepage in:
              </p>
              <div style={{
                fontSize: "2.5rem",
                fontWeight: "bold",
                color: "#007bff",
                marginBottom: "15px"
              }}>
                {countdown}
              </div>
              <p style={{ color: "#6c757d", fontSize: "0.9rem", margin: 0 }}>
                seconds
              </p>
            </div>

            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
              <Button
                primary
                label="Take Me Home Now"
                onPress={handleGoHome}
              />
              <Button
                label="Find a Boat"
                onPress={() => navigate("/search")}
              />
            </div>

            <div className="mt-4">
              <p style={{ color: "#888", fontSize: "0.9rem" }}>
                Need help? <a href="/contact" style={{ color: "#007bff" }}>Contact our crew</a> and we'll get you sailing smooth!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default NotFoundPage
